export const projectTypes = [
  { value: "website", label: "Website", detail: "A clear online home for your business." },
  { value: "app", label: "App & Software", detail: "A useful tool built around the way you work." },
  { value: "unsure", label: "Not sure yet", detail: "Start with what you want to achieve." },
];

export const projectGoals = {
  website: [
    { value: "introduce", label: "Introduce my company" },
    { value: "showcase", label: "Showcase products or services" },
    { value: "enquiries", label: "Generate customer enquiries" },
  ],
  app: [
    { value: "booking", label: "Manage bookings" },
    { value: "workflow", label: "Simplify a workflow" },
    { value: "information", label: "Manage information in one place" },
  ],
  unsure: [
    { value: "presence", label: "Build an online presence" },
    { value: "customers", label: "Make things easier for customers" },
    { value: "operations", label: "Make daily work easier" },
  ],
};

export const projectStages = [
  { value: "new", label: "Starting fresh" },
  { value: "existing", label: "Improving something existing" },
  { value: "exploring", label: "Exploring an idea" },
];

export function updateAnswer(answers, key, value) {
  const next = { ...answers, [key]: value };
  if (key === "type" && answers.type !== value) next.goal = "";
  return next;
}

export function getStartingPoint(answers) {
  const type = projectTypes.find((item) => item.value === answers.type);
  const goal = projectGoals[answers.type]?.find((item) => item.value === answers.goal);
  const stage = projectStages.find((item) => item.value === answers.stage);
  if (!type || !goal || !stage) return null;

  const suggestions = {
    introduce: ["Company website", "Start with a clear introduction, your services and an easy way to get in touch."],
    showcase: ["Product or service website", "Start with a focused structure that helps visitors explore what you offer and ask for details."],
    enquiries: ["Enquiry-focused website", "Start with a clear offer, useful service information and a straightforward enquiry journey."],
    booking: ["Booking app or software", "Start by mapping how a booking is created, managed and updated. The right platform needs a closer look at your requirements."],
    workflow: ["Workflow app or software", "Start with one workflow, the people involved and the hand-offs that need to become simpler."],
    information: ["Information management software", "Start with the information your team needs, who can access it and how it should stay up to date."],
    presence: ["Explore a website first", "A website may be a useful starting point. Let’s clarify what visitors should learn or do before choosing a solution."],
    customers: ["Explore the customer journey", "Let’s identify the customer task first. A website, app or smaller improvement may be the right fit."],
    operations: ["Explore a focused business tool", "Let’s map the daily task and the tools you already use before deciding whether custom software is needed."],
  };
  const [title, base] = suggestions[goal.value];
  const stageNote = {
    new: "We can begin by clarifying the first useful version.",
    existing: "We should review what already works before proposing changes.",
    exploring: "This can begin as a requirements discussion; no solution is fixed yet.",
  }[stage.value];
  return {
    title,
    body: `${base} ${stageNote}`,
    type: type.value,
    summary: `Project type: ${type.label}\nMain goal: ${goal.label}\nStarting point: ${stage.label}`,
    rows: [["Project", type.label], ["Goal", goal.label], ["Stage", stage.label]],
  };
}

// A transfer must never replace a customer's edited summary.
export function canTransferSummary(current, lastGenerated = "") {
  return !current.trim() || current === lastGenerated;
}
